export interface RouteSection {
	base: string
	create: string
	edit: (id: number | string) => string
	show: (id: number | string) => string
}

function getRouteSections(name: string): RouteSection {
	return {
		base: `/${name}`,
		create: `/${name}/create`,
		edit: (id: number | string) => `/${name}/${id}/edit`,
		show: (id: number | string) => `/${name}/${id}`,
	}
}

export const ROUTES = {
	home: '/',
	core: getRouteSections('core'),
	engineers: getRouteSections('engineers'),
	materialTypes: getRouteSections('material_types'),
	operations: getRouteSections('operations'),
	operationFamilies: getRouteSections('recipes'),
	technology: getRouteSections('technology'),
	sites: getRouteSections('sites'),
	sheets: {
		base: '/sheets',
		show: (id: number | string) => `/sheets/${id}`,
		edit: (id: number | string) => `/sheets/${id}/edit`,
		showRevision: (sheetId: number | string, revision: number | string) => `/sheets/${sheetId}/revision/${revision}`,
	},
	template: { ...getRouteSections('template'), edit: '/template/edit' },
	workstations: getRouteSections('workstations'),
	workstationGroups: {
		base: '/workstations/groups',
		create: '/workstations/groups/create',
		edit: (id: number | string) => `/workstations/groups/${id}/edit`,
		show: (id: number | string) => `/workstations/groups/${id}`,
	},
	engineerGroups: {
		base: '/engineers/groups',
		create: '/engineers/groups/create',
		edit: (id: number | string) => `/engineers/groups/${id}/edit`,
		show: (id: number | string) => `/engineers/groups/${id}`,
	},
	login: '/login',
	jobDelayReasons: { base: '/job_delay_reasons' },
	suggestions: getRouteSections('suggestions'),
	jobs: {
		base: '/jobs',
		show: (id: number | string) => `/jobs/${id}`,
		createSheet: (id: number | string) => `/jobs/${id}/sheets/create`,
	},
	opt: {
		base: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/opportunities`,
		operations: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/operations`,
		technologies: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/technologies`,
		lookupTables: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/lookups`,
		dataStore: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/data-store`,
		coreFormulas: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/core`,
		suggestions: `${process.env.NEXT_PUBLIC_OPT_BASE_URL ?? ''}/suggestions`,
	},
} as const
